import {
  RICH_TEXT_DISPLAY_CLASSNAME,
  hasRichTextContent,
  sanitizeRichTextHtml,
} from '@/shared/lib/rich-text-html'
import { cn } from '@/shared/lib/utils'
import { t } from '@/shared/lib/i18n'

interface TaskNotesPanelProps {
  notes: string | null | undefined
  className?: string
}

/**
 * Read-only task notes for the instrument Tasks tab (REBUILD-359).
 *
 * Notes are authored in the rich-text editor and migrated content comes from legacy Quill,
 * so the value is HTML: headings, coloured text, hyperlinks, lists and images. Legacy piped
 * it through `[innerHTML]` inside a `.ql-editor`; here it goes through the shared sanitizer
 * so the same formatting — including `<img>` — survives.
 */
export const TaskNotesPanel = ({ notes, className }: TaskNotesPanelProps) => {
  if (!hasRichTextContent(notes)) return null

  return (
    <section
      className={cn('space-y-2 rounded-lg border p-3', className)}
      data-testid="task-notes-panel"
    >
      <h2 className="text-sm font-semibold">{t('instruments.show.tasks.notesLabel')}</h2>
      <div
        className={RICH_TEXT_DISPLAY_CLASSNAME}
        dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(notes ?? '') }}
      />
    </section>
  )
}

export default TaskNotesPanel
